import React, { useState } from 'react'
import Calendar from '../../../components/Calendar/Calendar'
import Button from '../../../components/Button/Button'
import { showSnackBar } from '../../../components/Snackbar/Snackbar'
import { useMyContextLoading } from '../../../components/LoadingContextProvider/LoadingContextProvider'
import { downloadPaymentCsv } from '../../../features/paymentExport/paymentExport'
import { startOfMonth, endOfMonth } from '../../../utils/date'

const PaymentExport = () => {
  const { triggerLoading } = useMyContextLoading()
  const [startDate, setStartDate] = useState(startOfMonth())
  const [endDate, setEndDate] = useState(endOfMonth())
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleExport = async () => {
    if (startDate.isAfter(endDate)) {
      showSnackBar('error', 'Start date must be before end date')
      return
    }

    setIsSubmitting(true)
    triggerLoading(true)

    try {
      const formattedStartDate = startDate.format('YYYY-MM-DD')
      const formattedEndDate = endDate.format('YYYY-MM-DD')

      await downloadPaymentCsv({ startDate: formattedStartDate, endDate: formattedEndDate, type: 'ach' })
      await downloadPaymentCsv({ startDate: formattedStartDate, endDate: formattedEndDate, type: 'cc' })

      showSnackBar('success', 'Payment lists downloaded successfully!')
    } catch (error) {
      showSnackBar('error', error?.response?.data?.message || 'Failed to download export')
    } finally {
      setIsSubmitting(false)
      triggerLoading(false)
    }
  }

  return (
    <div>
      <h2 className="text-xl font-semibold mb-4">Payment Lists Export</h2>
      <p className="text-text-secondary mb-6">
        Export ACH and Credit Card payment lists for the selected date range.
        Two CSV files will be downloaded.
      </p>

      <div className="flex flex-col gap-4 max-w-md">
        <div className="flex gap-4 items-end">
          <div className="flex-1">
            <label className="block text-sm font-medium text-text-secondary mb-1">Start Date</label>
            <Calendar
              value={startDate}
              onChange={setStartDate}
            />
          </div>
          <div className="flex-1">
            <label className="block text-sm font-medium text-text-secondary mb-1">End Date</label>
            <Calendar
              value={endDate}
              onChange={setEndDate}
            />
          </div>
        </div>

        <Button
          onClick={handleExport}
          disabled={isSubmitting}
        >
          {isSubmitting ? 'Downloading...' : 'Download Payment Lists'}
        </Button>
      </div>
    </div>
  )
}

export default PaymentExport
